module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 660406191216,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.0783807620518634,
		"cl_weight": 0.26516426576080354,
		"fossil_bank_score": 31.381,
		"fossil_insure_score": 21.4118,
		"wff_mil_weight": 0.04509429809886165,
		"mmc_weight": 0.04509429809886165,
		"cm_weight": 0.007302870272613039,
		"nw_weight": 0.024565830837760986,
		"wff_civ_weight": 0.009072591380077082,
		"gm_weight": 0.0014520275780280653,
		"gr_weight": 0.007620563802049017,
		"t_all_weight": 0.016955216304470482,
		"to_weight": 0.006790390654397736,
		"tm_weight": 0.010164825650072753,
		"po_producer_weight": 0.001660680959717517,
		"po_financier_weight": 0.027943541139159107,
		"po_consumer_weight": 0.11100629593062178,
		"pp_weight": 0.19647456550188336,
		"borders_weight": 0.18565324420160284,
		"pp_high_weight": 0.0033004787955545414,
		"borders_high_weight": 0.01997308546229185,
		"pff_all_weight": 0.22835129082418112,
		"pff_all_high_weight": 0.01997308546229185,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.82722741750513,
		"gef_score_a": 26.703936557635853,
		"gef_score_b": 9.059416585215185,
		"gef_score_c": 18.398147800397993,
		"gef_score_d": 0.6657264742428398,
		"gef_score_a_norm": 66.75984139408963,
		"gef_score_b_norm": 30.198055284050618,
		"gef_score_c_norm": 91.99073900198997,
		"gef_score_d_norm": 6.657264742428398,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": 2.02807,
		"trailing_return_m3": 9.61806,
		"trailing_return_m6": 9.19844,
		"trailing_return_y1": 15.84686,
		"trailing_return_y3": 19.50662,
		"trailing_return_y5": 14.70938,
		"trailing_return_y10": 14.56347,
		"trailing_return_y15": 14.96934,
		"trailing_return_y20": 10.76648,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 16581507743,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.0765906415730739,
		"cl_weight": 0.232564791662853,
		"fossil_bank_score": 27.6582,
		"fossil_insure_score": 18.9923,
		"wff_mil_weight": 0.04506437993800274,
		"mmc_weight": 0.04506437993800274,
		"cm_weight": 0.006512361572666492,
		"nw_weight": 0.0241512172158994,
		"wff_civ_weight": 0.008346251755425263,
		"gm_weight": 0.0013423201255614826,
		"gr_weight": 0.007003931629863777,
		"t_all_weight": 0.014750533758375744,
		"to_weight": 0.0060128276214641155,
		"tm_weight": 0.008737706136911627,
		"po_producer_weight": 0.0014484266004461664,
		"po_financier_weight": 0.024573395700408302,
		"po_consumer_weight": 0.09936330064614254,
		"pp_weight": 0.17456809307050397,
		"borders_weight": 0.16580554491298286,
		"pp_high_weight": 0.0031750712504321488,
		"borders_high_weight": 0.01871767421232635,
		"pff_all_weight": 0.20399762923274214,
		"pff_all_high_weight": 0.018726239479775166,
		"pff_all_extreme_weight": 0.00007812226298237182,
		"gef_score_norm": 53.26181446979056,
		"gef_score_a": 26.054272050932173,
		"gef_score_b": 8.528762654067954,
		"gef_score_c": 18.074595662067424,
		"gef_score_d": 0.6041841027111788,
		"gef_score_a_norm": 65.13568012733043,
		"gef_score_b_norm": 28.42920884689318,
		"gef_score_c_norm": 90.37297831033712,
		"gef_score_d_norm": 6.041841027111788,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": 2.29916,
		"trailing_return_m3": 9.8198,
		"trailing_return_m6": 9.18533,
		"trailing_return_y1": 15.61226,
		"trailing_return_y3": 18.60921,
		"trailing_return_y5": 13.91785,
		"trailing_return_y10": 13.79536,
		"trailing_return_y15": 14.46412,
		"trailing_return_y20": 10.43815,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 66378411590,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.06815325102247752,
		"cl_weight": 0.0032664919907885,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.03370216833975423,
		"mmc_weight": 0.03370216833975423,
		"cm_weight": 0.002678556586399195,
		"nw_weight": 0.011280805760594051,
		"wff_civ_weight": 0.0018924449913133299,
		"gm_weight": 0.0006053231600694061,
		"gr_weight": 0.0012871218312439237,
		"t_all_weight": 0.0015539529469197095,
		"to_weight": 0.0011125597488813883,
		"tm_weight": 0.00044139319803832125,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.003897696206756935,
		"pp_weight": 0.004393215219271299,
		"borders_weight": 0.009680308882741039,
		"pp_high_weight": 0.002436939463447693,
		"borders_high_weight": 0.003953331715768114,
		"pff_all_weight": 0.011834441919612287,
		"pff_all_high_weight": 0.004151188996815755,
		"pff_all_extreme_weight": 0.001816136489575969,
		"gef_score_norm": 37.4536579318384,
		"gef_score_a": 19.10605480846044,
		"gef_score_b": 3.315665108084959,
		"gef_score_c": 14.999013532204735,
		"gef_score_d": 0.03292448309435126,
		"gef_score_a_norm": 47.76513702115109,
		"gef_score_b_norm": 11.052217026949863,
		"gef_score_c_norm": 74.99506766102367,
		"gef_score_d_norm": 0.3292448309435126,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 7.12752,
		"trailing_return_m3": 14.84622,
		"trailing_return_m6": 10.13976,
		"trailing_return_y1": 8.03932,
		"trailing_return_y3": 10.14304,
		"trailing_return_y5": 9.99108,
		"trailing_return_y10": 8.81375,
		"trailing_return_y15": 11.01861,
		"trailing_return_y20": 7.96952,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 43654972832,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07702973925271078,
		"cl_weight": 0.24312897763925406,
		"fossil_bank_score": 28.9306,
		"fossil_insure_score": 19.8587,
		"wff_mil_weight": 0.04553209930626441,
		"mmc_weight": 0.04553209930626441,
		"cm_weight": 0.006703212638086099,
		"nw_weight": 0.024714036494971052,
		"wff_civ_weight": 0.008633988393453676,
		"gm_weight": 0.0013859004582310692,
		"gr_weight": 0.007248087935222607,
		"t_all_weight": 0.015373592656524009,
		"to_weight": 0.006247536335391789,
		"tm_weight": 0.009126056321132218,
		"po_producer_weight": 0.0015195363021699823,
		"po_financier_weight": 0.025703284975647223,
		"po_consumer_weight": 0.10379300570341599,
		"pp_weight": 0.18235341382776693,
		"borders_weight": 0.1729624514666124,
		"pp_high_weight": 0.003210661482268771,
		"borders_high_weight": 0.01941399010922376,
		"pff_all_weight": 0.21279895582509356,
		"pff_all_high_weight": 0.01941399010922376,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.73891682176378,
		"gef_score_a": 26.263879822182822,
		"gef_score_b": 8.68681285422735,
		"gef_score_c": 18.16666957881617,
		"gef_score_d": 0.6215545665250845,
		"gef_score_a_norm": 65.65969955545705,
		"gef_score_b_norm": 28.956042847424502,
		"gef_score_c_norm": 90.83334789408084,
		"gef_score_d_norm": 6.215545665250845,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": 2.09504,
		"trailing_return_m3": 9.62105,
		"trailing_return_m6": 9.17532,
		"trailing_return_y1": 16.06124,
		"trailing_return_y3": 19.1495,
		"trailing_return_y5": 14.18727,
		"trailing_return_y10": 14.17683,
		"trailing_return_y15": 14.75307,
		"trailing_return_y20": 10.65156,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 66065672663,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 5,
		"c2f5coogutweight": 0.10986796487687348,
		"cl_weight": 0.12660444882556765,
		"fossil_bank_score": 31.7095,
		"fossil_insure_score": 22.1476,
		"wff_mil_weight": 0.057098947043100874,
		"mmc_weight": 0.057098947043100874,
		"cm_weight": 0.009658616349205397,
		"nw_weight": 0.027909779315051127,
		"wff_civ_weight": 0.00481630080051677,
		"gm_weight": 0.00481630080051677,
		"gr_weight": 0,
		"t_all_weight": 0.01849671116695106,
		"to_weight": 0.009710268317000687,
		"tm_weight": 0.008786442849950372,
		"po_producer_weight": 0.014759472038723687,
		"po_financier_weight": 0.08801092685435027,
		"po_consumer_weight": 0.1001070101765757,
		"pp_weight": 0.014950764327417673,
		"borders_weight": 0.03061806856859838,
		"pp_high_weight": 0.0007336351962898488,
		"borders_high_weight": 0.007089131342230837,
		"pff_all_weight": 0.03292173600155566,
		"pff_all_high_weight": 0.007822766538520685,
		"pff_all_extreme_weight": 0.00027268620356782163,
		"gef_score_norm": 58.49848408150985,
		"gef_score_a": 25.784615754835997,
		"gef_score_b": 13.877903729482863,
		"gef_score_c": 17.5118969017353,
		"gef_score_d": 1.3240676954501287,
		"gef_score_a_norm": 64.46153938709,
		"gef_score_b_norm": 46.259679098276216,
		"gef_score_c_norm": 87.5594845086765,
		"gef_score_d_norm": 13.240676954501287,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 4.76203,
		"trailing_return_m3": 4.69079,
		"trailing_return_m6": 13.71527,
		"trailing_return_y1": 13.36737,
		"trailing_return_y3": 17.13437,
		"trailing_return_y5": 10.13783,
		"trailing_return_y10": 7.36368,
		"trailing_return_y15": 7.21582,
		"trailing_return_y20": 5.59825,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 18916662029,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.09286422559301298,
		"cl_weight": 0.1368404938775955,
		"fossil_bank_score": 7.9998,
		"fossil_insure_score": 7.4418,
		"wff_mil_weight": 0.03471867542224205,
		"mmc_weight": 0.03471867542224205,
		"cm_weight": 0.006309120542431716,
		"nw_weight": 0.0175576500578453,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.00315319262240446,
		"to_weight": 0.00315319262240446,
		"tm_weight": 0,
		"po_producer_weight": 0.009993915315661886,
		"po_financier_weight": 0.018713448799957486,
		"po_consumer_weight": 0.008918006721649713,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 48.94865451477226,
		"gef_score_a": 23.728178160859073,
		"gef_score_b": 7.97637004364118,
		"gef_score_c": 16.663651391689125,
		"gef_score_d": 0.5804549185987653,
		"gef_score_a_norm": 59.32044540214768,
		"gef_score_b_norm": 26.5879001454706,
		"gef_score_c_norm": 83.31825695844563,
		"gef_score_d_norm": 5.804549185987653,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": 2.09175,
		"trailing_return_m3": 10.29182,
		"trailing_return_m6": 16.57629,
		"trailing_return_y1": 17.69084,
		"trailing_return_y3": 10.59569,
		"trailing_return_y5": 4.58671,
		"trailing_return_y10": 6.30246,
		"trailing_return_y15": 3.63186,
		"trailing_return_y20": 5.43095,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 6625903679,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.1147501859585992,
		"cl_weight": 0.12714512114354354,
		"fossil_bank_score": 32.1513,
		"fossil_insure_score": 17.1033,
		"wff_mil_weight": 0.048354086137965296,
		"mmc_weight": 0.048354086137965296,
		"cm_weight": 0.0078439144047264,
		"nw_weight": 0.02482423036198978,
		"wff_civ_weight": 0.0030201102407844444,
		"gm_weight": 0.0030201102407844444,
		"gr_weight": 0,
		"t_all_weight": 0.01241110428392469,
		"to_weight": 0.006913594718027442,
		"tm_weight": 0.00549750956589725,
		"po_producer_weight": 0.012112137405088104,
		"po_financier_weight": 0.06036530136812866,
		"po_consumer_weight": 0.06655163040309212,
		"pp_weight": 0.011030481443050301,
		"borders_weight": 0.0200971280953761,
		"pp_high_weight": 0.0004554513133862212,
		"borders_high_weight": 0.005351589561169171,
		"pff_all_weight": 0.023243719213562445,
		"pff_all_high_weight": 0.005807040874555393,
		"pff_all_extreme_weight": 0.00016895131441137958,
		"gef_score_norm": 57.34487888794476,
		"gef_score_a": 25.660301099788235,
		"gef_score_b": 12.956878765476977,
		"gef_score_c": 17.472095842217964,
		"gef_score_d": 1.2556031804567331,
		"gef_score_a_norm": 64.15075274947058,
		"gef_score_b_norm": 43.18959588492326,
		"gef_score_c_norm": 87.36047921108982,
		"gef_score_d_norm": 12.556031804567331,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 4.03836,
		"trailing_return_m3": 6.67191,
		"trailing_return_m6": 15.00985,
		"trailing_return_y1": 15.40446,
		"trailing_return_y3": 15.28547,
		"trailing_return_y5": 8.80931,
		"trailing_return_y10": 7.20917,
		"trailing_return_y15": 6.31721,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 22045899270,
		"grade_fossil": 4,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.08806084719915987,
		"cl_weight": 0.2099480082275287,
		"fossil_bank_score": 31.3857,
		"fossil_insure_score": 16.7783,
		"wff_mil_weight": 0.04599450082368851,
		"mmc_weight": 0.04599450082368851,
		"cm_weight": 0.0073173743711193095,
		"nw_weight": 0.024577606881039337,
		"wff_civ_weight": 0.006990160760207275,
		"gm_weight": 0.0019871349451187504,
		"gr_weight": 0.005003025815088525,
		"t_all_weight": 0.014921564502574154,
		"to_weight": 0.006733814379988286,
		"tm_weight": 0.008187750122585869,
		"po_producer_weight": 0.005282331082134109,
		"po_financier_weight": 0.039292766029430694,
		"po_consumer_weight": 0.09346834275078382,
		"pp_weight": 0.12313346935585134,
		"borders_weight": 0.12290940769318089,
		"pp_high_weight": 0.002257097780918207,
		"borders_high_weight": 0.014926021856403225,
		"pff_all_weight": 0.14811629082582933,
		"pff_all_high_weight": 0.015087695356669496,
		"pff_all_extreme_weight": 0.0000608785098291995,
		"gef_score_norm": 55.281426624732234,
		"gef_score_a": 26.270110971853676,
		"gef_score_b": 10.097662854844689,
		"gef_score_c": 18.098310000227826,
		"gef_score_d": 0.8153427977951286,
		"gef_score_a_norm": 65.67527742963419,
		"gef_score_b_norm": 33.658876182815625,
		"gef_score_c_norm": 90.49155000113913,
		"gef_score_d_norm": 8.153427977951285,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 2.67616,
		"trailing_return_m3": 8.53633,
		"trailing_return_m6": 11.20529,
		"trailing_return_y1": 15.86589,
		"trailing_return_y3": 17.78479,
		"trailing_return_y5": 12.0231,
		"trailing_return_y10": 11.25868,
		"trailing_return_y15": 10.71182,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-08-31T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 958
// module chunks = 0